import * as React from "react";

function SvgBackupDelete(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.2708 4.45239V7.23511C27.2708 9.68742 21.1633 11.6875 13.6354 11.6875C6.10751 11.6875 0 9.68742 0 7.23511V4.45239C0 2.00008 6.10751 0 13.6354 0C21.1633 0 27.2708 2.00008 27.2708 4.45239ZM27.2708 16.2012C26.2865 15.8027 25.2105 15.5833 24.0833 15.5833C20.342 15.5833 17.1652 18.0005 16.0295 21.3584C15.8135 21.9971 15.6713 22.6699 15.6131 23.3665C15.5934 23.6028 15.5833 23.8419 15.5833 24.0833C15.5833 26.8271 16.8834 29.2673 18.9011 30.8214C20.3356 31.9263 22.1327 32.5833 24.0833 32.5833C28.7778 32.5833 32.5833 28.7778 32.5833 24.0833C32.5833 20.5161 30.3859 17.4621 27.2708 16.2012ZM14.1894 23.4064C14.0048 23.4087 13.8201 23.4098 13.6354 23.4098C8.29131 23.4098 2.92948 22.4706 0 20.4531V26.7143C0 29.1666 6.10751 31.1667 13.6354 31.1667C14.7984 31.1667 15.9276 31.1189 17.0055 31.0292C18.805 32.8627 21.3113 34 24.0833 34C29.5602 34 34 29.5602 34 24.0833C34 19.7216 31.184 16.0175 27.2708 14.6901V10.7135C24.3413 12.731 18.9795 13.6702 13.6354 13.6702C8.29131 13.6702 2.92948 12.731 0 10.7135V16.9747C0 19.427 6.10751 21.4271 13.6354 21.4271C13.9357 21.4271 14.2336 21.4239 14.5291 21.4176C14.3511 22.0569 14.2355 22.7222 14.1894 23.4064ZM19 21V19.5H22V18H26V19.5H29V21H19ZM23 19.5V19H25V19.5H23ZM28 22H20V30H28V22ZM21.5 23.5V28.5H22.5V23.5H21.5ZM23.5 28.5V23.5H24.5V28.5H23.5ZM25.5 23.5V28.5H26.5V23.5H25.5Z"
        fill="#9E9E9E"
      />
    </svg>
  );
}

export default SvgBackupDelete;
